import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  setItemTableWrapper: {
    border: `1px solid ${theme.palette.paper.borderColor}`,
    borderRadius: '10px',
    // overflow: 'hidden',
    position: 'relative',
  },
  setItemListHeader: {
    minHeight: theme.spacing(5),
    alignItems: 'center',
    padding: theme.spacing(0.5, 1),
    borderRadius: '10px 10px 0 0',
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.border.main}`,
  },
  setItemListRow: {
    height: theme.spacing(5),
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),

    '&:not(:last-child)': {
      borderBottom: `1px solid ${theme.palette.border.main}`,
    },
  },
  oddRow: {
    background: theme.palette.exerciseStatus.notStartedOddLine,
  },
  saveSetButton: {
    position: 'absolute',
    top: theme.spacing(-5),
    right: 0,
  },

  headerTextWrapper: {
    minWidth: 0,
    textTransform: 'capitalize',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
    padding: theme.spacing(0, 0.5, 0, 0),
  },
}));
